var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaidRoom = function SvgMaidRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m16.02 1.974-8.14.045A5.96 5.96 0 0 0 1.954 8.01l.044 8.08a5.96 5.96 0 0 0 5.992 5.927l8.14-.044a5.96 5.96 0 0 0 5.928-5.992l-.044-8.08a5.96 5.96 0 0 0-5.992-5.928",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 15.711a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M18.5 21.47a6.89 6.89 0 0 0-13 0c.784.358 1.638.54 2.5.53h8.13a6.1 6.1 0 0 0 2.37-.53"
  })));
};
export default SvgMaidRoom;